import { createNote } from "../db/actions";

/**
 * Evernote's "new note" from anywhere (the Note pill, the phone's +, Ctrl+N/Ctrl+Alt+N): in the notebook
 * you're looking at, tagged with the tag you're looking at, else in the default notebook; then it opens in
 * that same list.
 */
export async function newNoteHere(path: string, navigate: (to: string) => void): Promise<string> {
  const nb = /^\/notebook\/([^/?]+)/.exec(path)?.[1];
  const tag = /^\/tag\/([^/?]+)/.exec(path)?.[1];
  const id = await createNote(nb ? { notebookId: nb } : tag ? { tagIds: [tag] } : {});
  navigate(nb ? `/notebook/${nb}?n=${id}` : tag ? `/tag/${tag}?n=${id}` : `/notes?n=${id}`);
  return id;
}
